import {useQuery} from "@tanstack/react-query";
import axios from "axios";
import {ResponseList} from "../../../models/common/Response";
import {BucketCompanyCode} from "../../../models/config/BucketCompanyCode";

export const useBucketCompanyCodeMapping = () => {
    return useQuery({
        queryKey: ['bucket-company-code-mapping'],
        queryFn: ({ signal }) => {
            const accessToken = localStorage.getItem('LG_APPLICATION');
            return axios.get<ResponseList<BucketCompanyCode>>(
                '/v1/configuration/lis/bucket-company-code-mapping',
                {
                    signal,
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                }
            );
        },
        select: response => response.data.result_list,
        retry: 1,
    });
}